import React, { useCallback, useMemo, useRef, useState } from 'react';

const DEFAULT_LIMIT = 25;
const NEXT_LIMIT = 100;

const SpinnerLine = () => (
	<div className="position-absolute w-100 h-100" style={{left:0,opacity:0.5,top:0,zIndex:1}}>
		<div className="spinner-border position-absolute" style={{left:'calc(50% - 15px)',top:'calc(50% - 15px)'}} />
	</div>
);

/**
 * Custom hook for "Load More" button
 */
export default ({ filters_ref, position = 'relative', rankings_key } = {}) => {
	const offset = useRef(0);
	const setOffset = useCallback(value => offset.current = value);
	const limit = useRef(DEFAULT_LIMIT);
	const setLimit = useCallback(value => limit.current = value);
	const [rows, setRows] = useState([]);
	const [total, setTotal] = useState(null);
	const remain = total === null ? 100 : total - (rows || []).length;
	const [isLoadingMore, setIsLoadingMore] = useState(false);
	const setDefaults = useCallback(() => {
		setOffset(0);
		setLimit(DEFAULT_LIMIT);
	});
	const loadMore = useCallback(limit => {
		setOffset(rows.length);
		setLimit(limit ? limit : NEXT_LIMIT);
		setIsLoadingMore(true);
	});
	const loadMoreButton = useMemo(() => {
		if (remain > 0) {
			const can_load_remain = remain <= 4000;
			return (
				<>
					{isLoadingMore ? (
						<div className="row g-0 mt-4 mx-auto" style={{bottom: position === 'absolute' ? 0 : 0, height:'50px', left: 0, position, right: 0}}>
							<SpinnerLine />
						</div>
					) : (
						<div className="row g-0 mt-4 mx-auto" style={{bottom: position === 'absolute' ? 0 : 0, height:'50px', left: 0, position, right: 0}}>
							<div className="col-auto mx-auto">
								<button className="btn btn-secondary" onClick={() => loadMore()}>Load {Math.min(NEXT_LIMIT, remain)} More</button>
								{remain > 500 && (
									<button className="btn btn-secondary ms-3" onClick={() => loadMore(500)}>Load {Math.min(500, remain)} More</button>
								)}
								{remain > NEXT_LIMIT && can_load_remain && <a className="btn-link ms-3" role="button" onClick={() => loadMore(remain)}>Remaining {remain}</a>}
								{remain > NEXT_LIMIT && !can_load_remain && <span className="ms-3">Remaining {remain}</span>}
							</div>
						</div>
					)}
				</>
			);
		}
	}, [isLoadingMore, remain, loadMore]);
	return {
		isLoadingMore,
		limit: limit.current,
		loadMoreButton,
		offset: offset.current,
		rows,
		setDefaults,
		setIsLoadingMore,
		setLimit,
		setOffset,
		setRows,
		setTotal,
		total
	};
};
